import React from 'react';
import styles from "./weightLossCardBlock.module.scss";
import locales from "../../../../content.json";

const WeightLossCardBlock = ({
    firstDate, secondDate, currentWeight, 
    goalWeight, weightType, animation}) => {

    let weightTypeLocales = weightType === "lbs" 
        ? locales[window.userLang].lbs_value
        : locales[window.userLang].kg_value;

    return (
    <div className={styles.card }>
        <div className={styles.card_title}>
            <svg aria-hidden="true" className={styles.card_title_icon} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M0 3C0 1.34315 1.34315 0 3 0H13C14.6569 0 16 1.34315 16 3V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V3ZM13.5219 3.55019C11.7942 2.73284 9.93622 2.31836 7.99972 2.31836C6.06321 2.31836 4.20519 2.73268 2.47736 3.55002C2.28367 3.64164 2.18969 3.8643 2.25908 4.06707L3.25075 6.96257C3.29049 7.07844 3.37875 7.17141 3.49243 7.21689C3.60612 7.26253 3.73395 7.2563 3.84292 7.19988C5.13369 6.53108 6.53209 6.19187 7.99972 6.19187C8.13156 6.19187 8.26284 6.19461 8.39354 6.20008L9.02474 3.66847C9.14187 3.1987 9.61764 2.91282 10.0874 3.02995C10.5572 3.14708 10.8431 3.62285 10.7259 4.09263L10.1397 6.44391C10.8358 6.61231 11.5097 6.86471 12.1565 7.19988C12.2171 7.23137 12.2835 7.24703 12.3502 7.24703C12.4033 7.24703 12.4565 7.23693 12.507 7.21672C12.6207 7.17107 12.7089 7.07828 12.7487 6.9624L13.7403 4.06691C13.8096 3.8643 13.7156 3.64181 13.5219 3.55019Z" fill="white" />
            </svg>
            <span>{locales[window.userLang].weight_loss_card_title}</span>
            </div>
            <div className={`${styles.card_chart} ${animation}`}>
                <svg aria-hidden="true" width="296" height="165" viewBox="0 0 296 165" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_d-card)">
                    <path d="M276 5H277V149.742H276V5Z" fill="url(#paint0_linear-card)" shapeRendering="crispEdges" />
                </g>
                <rect x="275.75" y="154.75" width="1.5" height="1.5" rx="0.75" fill="#ACA8C6" stroke="white" strokeWidth="1.5" />
                <g filter="url(#filter1_d-card)">
                    <path d="M19 5H20V149.742H19V5Z" fill="url(#paint1_linear-card)" shapeRendering="crispEdges" />
                </g>
            <rect x="18.75" y="154.75" width="1.5" height="1.5" rx="0.75" fill="#ACA8C6" stroke="white" strokeWidth="1.5" />
            <path d="M1 5H19V149L1 148.563V5Z" fill="url(#paint2_linear-card)" fillOpacity="0.1" />
            <g opacity="0.2">
                <path fillRule="evenodd" clipRule="evenodd" d="M1 77.25L295 77.75L1 77.25Z" fill="white" />
                <path d="M1 77.25L295 77.75" stroke="white" strokeOpacity="0.5" strokeWidth="0.5" strokeLinecap="square" />
            </g>
            <g opacity="0.2">
                <path fillRule="evenodd" clipRule="evenodd" d="M1 41.25L295 41.75L1 41.25Z" fill="white" />
                <path d="M1 41.25L295 41.75" stroke="white" strokeOpacity="0.5" strokeWidth="0.5" strokeLinecap="square" />
            </g>
            <g opacity="0.2">
                <path fillRule="evenodd" clipRule="evenodd" d="M1 149.25L295 149.75L1 149.25Z" fill="white" />
                <path d="M1 149.25L295 149.75" stroke="white" strokeOpacity="0.5" strokeWidth="0.5" strokeLinecap="square" />
            </g>
            <g opacity="0.2">
                <path fillRule="evenodd" clipRule="evenodd" d="M1 113.25L295 113.75L1 113.25Z" fill="white" />
                <path d="M1 113.25L295 113.75" stroke="white" strokeOpacity="0.5" strokeWidth="0.5" strokeLinecap="square" />
            </g>
            <g opacity="0.2">
                <path fillRule="evenodd" clipRule="evenodd" d="M1 4.5L295 5.5L1 4.5Z" fill="white" />
                <path d="M1 4.5L295 5.5" stroke="white" strokeOpacity="0.5" strokeWidth="0.5" strokeLinecap="square" />
            </g>

            <rect x="15.5" y="40.5" width="7" height="7" rx="3.5" fill="#563AB4" stroke="white" strokeWidth="3" />
            <rect x="273.5" y="104.049" width="5" height="5" rx="2.5" fill="#563AB4" stroke="white" strokeWidth="3" />
            <defs>
                <filter id="filter0_d-card" x="266" y="0" width="21" height="164.742" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="5" />
                    <feGaussianBlur stdDeviation="5" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0.198516 0 0 0 0 0.0164063 0 0 0 0 0.2625 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
                </filter>
                <filter id="filter1_d-card" x="9" y="0" width="21" height="164.742" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="5" />
                    <feGaussianBlur stdDeviation="5" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0.198516 0 0 0 0 0.0164063 0 0 0 0 0.2625 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
                </filter>
                    <linearGradient id="paint0_linear-card" x1="276.989" y1="150" x2="276.989" y2="7.00334" gradientUnits="userSpaceOnUse">
                        <stop stopColor="white" stopOpacity="0.6" />
                        <stop offset="1" stopColor="white" stopOpacity="0.1" />
                    </linearGradient>
                    <linearGradient id="paint1_linear-card" x1="19.9892" y1="150" x2="19.9892" y2="7.00334" gradientUnits="userSpaceOnUse">
                        <stop stopColor="white" stopOpacity="0.6" />
                        <stop offset="1" stopColor="white" stopOpacity="0.1" />
                    </linearGradient>
                    <linearGradient id="paint2_linear-card" x1="19" y1="80.2561" x2="1" y2="80.2561" gradientUnits="userSpaceOnUse">
                        <stop stopColor="white" />
                        <stop offset="1" stopColor="white" stopOpacity="0" />
                    </linearGradient>
                    </defs>
                </svg>
                    <div className={styles.card_bubble + " " + styles.card_bubble1}>
                                <span className={styles.card_value}>{currentWeight}
                                    <span className={styles.card_units}> {weightTypeLocales}</span></span>
                    </div>
                    <div className={styles.card_bubble + " " + styles.card_bubble2}>
                                <span className={styles.card_value}>{goalWeight}
                                    <span className={styles.card_units}> {weightTypeLocales}</span></span>
                    </div>
                    <div className={styles.card_chart_line}></div>
            </div>
            <div className={styles.card_dates}>
                <div>
                    {firstDate}
                </div>
                <div>
                    {secondDate}
                </div>
            </div>
        </div>
    )
}

export default WeightLossCardBlock;